var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "button-container button-group-container",
      class: {
        "button-group-row-container": _vm.row,
        "button-group-column-container": !_vm.row,
      },
      style: {
        width: !_vm.row ? _vm.size + "px" : null,
        height: _vm.row ? _vm.size + "px" : null,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "button-group-sheet",
          class: { "button-group-sheet-column": !_vm.row },
          staticStyle: { "border-radius": "150px" },
        },
        [
          _vm._l(_vm.items, function (item, i) {
            return _c(
              "MapButton",
              {
                key: i + "" + item.titl,
                attrs: {
                  height: _vm.size,
                  text: "",
                  title: item.title,
                  width: _vm.size,
                },
                on: { click: item.onClick },
              },
              [_c("MapIcon", [_vm._v(" " + _vm._s(item.icon) + " ")])],
              1
            )
          }),
          _vm._t("default"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }